export default __webpack_public_path__ + "static/media/pro.27b571b6.png";